import type { SVGProps } from "react";
import * as React from "react";

const SvgHelpCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.147 8.668a1 1 0 1 0 1.886.664zM14.92 10l-1-.001V10zm-3.316 2.051a1 1 0 0 0 .632 1.898zM12 16a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm-1.967 6.332a2 2 0 0 1 .874-1.06L9.893 6.546a4 4 0 0 0-1.746 2.121zm.874-1.06a2 2 0 0 1 1.351-.248l.338-1.97a4 4 0 0 0-2.703.493zm1.351-.248a2 2 0 0 1 1.192.684l1.53-1.288a4 4 0 0 0-2.384-1.367zm1.192.684a2 2 0 0 1 .47 1.29l2 .004a4 4 0 0 0-.94-2.582zM13.92 10c0 .47-.365.958-1.055 1.418a6 6 0 0 1-1.246.628l-.016.006h-.002.002l.317.948c.316.949.316.949.317.948h.002l.004-.002.011-.003.035-.012.116-.043a8.044 8.044 0 0 0 1.57-.806c.81-.54 1.945-1.551 1.945-3.082zM12 18h.01v-2H12z"
    />
  </svg>
);
export default SvgHelpCircle;
